import { makeStyles } from 'tss-react/mui';

export const useChatHandlerStyles = makeStyles()((theme) => ({
  chatMessageWrapper: {
    zIndex: theme.zIndex.modal - 1,
    position: 'fixed',
    bottom: '16px',

    [theme.breakpoints.down('sm')]: {
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
    },
  },
  bubblesWrapper: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));
